import { Col, Input, Row, Select } from "antd"

export const Observaciones = ({ observaciones, estado, setEstado, tipoPostulacion }: any) => {
  return (
    <Row gutter={[24,24]}>
      <Col span={24}>
        <Input.TextArea rows={8} value={observaciones} readOnly></Input.TextArea>
      </Col>
      {(estado && tipoPostulacion === 'postulaciones') &&
        <Col span={12}>
          <Select value={estado} style={{width: '100%'}} onChange={(v) => setEstado(v)}>
            <Select.Option value="Aceptó">Aceptó</Select.Option>
            <Select.Option value="No aceptó">No aceptó</Select.Option>
            <Select.Option value="No responde">No responde</Select.Option>
            {/* <Select.Option value="Postulado">Postulado</Select.Option> */}
          </Select>
        </Col>
      }
    </Row>
  )
}
